import { Box, Heading, Flex } from 'theme-ui';

import { Accordions, Accordion, FilterOption } from '@snippets';

import { useCollectionFilters } from '../../hooks';
import { CurrentFilters } from '../CurrentFilters';
import { themed } from './DesktopFilters.theme';

export const DesktopFilters = themed(
  ({ theme, collection, collectionCategories, merchandising, hasHero }) => {
    const [{ filters }, { addToSelectedFilters, removeFromSelectedFilters }] =
      useCollectionFilters();

    const left = merchandising?.content?.left?.[0];

    const words = collection.title?.split(' ');
    const hasLongWord = words?.some((word) => word?.length > 8);

    return (
      <Box data-comp={DesktopFilters.displayName} sx={theme.wrapper}>
        {!hasHero && (
          <Heading as="h1" sx={theme.heading(hasLongWord)}>
            {collection?.title}
          </Heading>
        )}

        <Box sx={theme.sticky}>
          {collectionCategories}

          {filters?.length > 0 && (
            <Accordions
              textColor="text"
              borderColor="gray"
              iconColor="text"
              minHeight="52px"
              maxHeight="800px"
              oneOpenAtATime={false}
            >
              {filters?.map((filter) => {
                return (
                  <Accordion key={filter.label} collapsed={!!filter.collapse}>
                    <Accordion.Header sx={theme.accordionHeader.heading}>
                      {filter.label}
                    </Accordion.Header>

                    <Accordion.Body>
                      {({ isOpen }) =>
                        filter.values?.map((option) => {
                          return (
                            <Box key={option.label} as="li">
                              <FilterOption
                                option={option}
                                field={filter.field}
                                tabIndex={isOpen ? '0' : '-1'}
                                aria-hidden={isOpen ? 'false' : 'true'}
                                addToSelectedFilters={addToSelectedFilters}
                                removeFromSelectedFilters={
                                  removeFromSelectedFilters
                                }
                              />
                            </Box>
                          );
                        })
                      }
                    </Accordion.Body>
                  </Accordion>
                );
              })}
            </Accordions>
          )}

          <CurrentFilters />

          {left && (
            <Box
              dangerouslySetInnerHTML={{
                __html: left,
              }}
              sx={{ mt: 12, display: ['none', 'block'] }}
            />
          )}
        </Box>
      </Box>
    );
  }
);

DesktopFilters.displayName = 'DesktopFilters';
